import {Link} from '~library/atoms/Link';

export const GalleryPromoTile = ({data}) => {
  const {src, href, text, dataQaId = 'promo-tile-link'} = data;

  if (!src) return null;

  return (
    <Link
      href={href}
      as="transparent"
      className="gallery-promo-tile"
      data-qa-id={dataQaId}
      data-impression-tracking="true"
    >
      <img className="gallery-promo-tile__img" src={src} alt={`Promotional tile: ${text}`} />
    </Link>
  );
};
